import { Button, CircularProgress, Tooltip } from '@material-ui/core';
import { CheckIcon, SyncIcon } from './icons';
import moment from 'moment';
import { useState } from 'react';
import { doSwaggerCall } from './hooks/useSwaggerClient';
import { useEffect } from 'react';

const formatLastSync = syncTime => {
    if (!syncTime) {
        return 'Not synced yet';
    }
    return `Last synced: ${moment(moment().add(syncTime, 'seconds')).fromNow()}`;
};

export const TimeslotSyncInfo = ({ activity, timeslots_synced_age, onSyncComplete, fromDate, toDate }) => {
    const [lastSyncedAge, setLastSyncedAge] = useState(timeslots_synced_age);
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);

    useEffect(() => {
        setLastSyncedAge(timeslots_synced_age);
    }, [timeslots_synced_age]);

    // TODO: sync can take a while
    const handleSync = async () => {
        try {
            setLoading(true);
            setSuccess(false);
            await doSwaggerCall('activities', 'syncActivityTimeslots', {
                activityId: activity.id,
                fromDate,
                toDate
            });
            // assume sync was successful
            setLastSyncedAge(0);
            setLoading(false);
            setSuccess(true);
            // Reload timeslots after successful sync
            if (onSyncComplete) {
                onSyncComplete();
            }
            setTimeout(() => setSuccess(false), 3000);
        } catch (err) {
            setLoading(false);
        }
    };

    if (!Number.isInteger(timeslots_synced_age)) {
        return null;
    }

    return (
        <Tooltip placement="top" title={`Timeslot Sync (${formatLastSync(lastSyncedAge)})`}>
            <Button disabled={loading || success} onClick={handleSync} variant="contained">
                {loading ? <CircularProgress size={16} /> : success ? <CheckIcon /> : <SyncIcon />}
            </Button>
        </Tooltip>
    );
};
